export default __webpack_public_path__ + "static/media/Md.ad830f3b.png";